import React from 'react';
import {Button, Nav} from 'react-bootstrap';
import {useAuth} from "../authprovider";
import {
    Link,
    useLocation
} from "react-router-dom";

export default function Navigationbar()  {
    let location = useLocation();
    const auth = useAuth();
    const user = auth.user;

    let handleLoguot = ()=>{
        auth.signout()
    }

    const isActive = (path)=> path === location.pathname ? "active" : "";

    return (
            <Nav className={"position-relative"} variant="tabs" defaultActiveKey={location.pathname}>
                { user.isAdmin &&
                    <>
                        <Nav.Item>
                            <Link className={`nav-link ${isActive("/")}`} to="/">Obiekty</Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Link className={`nav-link ${isActive("/videos")}`} to="/videos">Filmy</Link>
                        </Nav.Item>
                    </>
                }
                {user.isSteward &&
                    <>
                        <Nav.Item>
                            <Link className={`nav-link ${isActive("/controll")}`} to="/controll">Panel kontrolny</Link>
                        </Nav.Item>
                    </>

                }
                {user.isManager &&
                    <>
                        <Nav.Item>
                            <Link className={`nav-link ${isActive("/controll")}`} to="/controll">Panel kontrolny</Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Link className={`nav-link ${isActive("/files")}`} to="/files">Pliki</Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Link className={`nav-link ${isActive("/users")}`} to="/users">Użytkownicy</Link>
                        </Nav.Item>
                    </>
                }

                <Button name={"Wyloguj"} onClick={handleLoguot} className={"position-absolute"} style={{"top": "2px", "right": "2rem"}} variant="outline-warning">Wyloguj</Button>
            </Nav>
        );

}

